import { type FunctionComponent, type PropsWithChildren, } from "react"


export declare type TabProps = PropsWithChildren<{
	label: string;
	route?: string;
	component?: any;
}>;


export const Tab: FunctionComponent<TabProps> = ({
	label,
	children,
	component,
}) => {

	const classes = () => [ `tab`, label, ].join(" ");
	const Component = component || null;

	return (
		<div className={classes()}>
			{ component && <Component /> }
			{ !component && children }
		</div>
	);

}
